module.exports = __webpack_public_path__ + "img/getty.bf6b4682.svg";